/* eslint-disable no-console */
import { Inject, Injectable } from '@angular/core';
import { ApisConstants } from '@src/app/core/constants/ib-checkin-apis-constants';
import { AJSRootScope, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { FormDataApis, FormDataApisInfant, SelectOptions } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/ApisForm.model';
import { DocumentForm } from 'commercial-management--digital--web-components-design--library/dist/components/layout/ApisForm/components/DocumentationRequired/DocumentationRequired.model';
import { Document, SecurityRequest } from '@src/app/core/models/ib-checkin-apis/services/security-model';
import { AdditonalInfoBody } from '@src/app/core/models/ib-checkin-apis/services/additional-info-model';

@Injectable({ providedIn: 'root' })
export class IbCheckinApisHttpTransformerService {
    constructor (@Inject(AJSRootScope) private $rootScope: CommonsRootScope, private CommonsSessionStorageService: CommonsSessionStorageService) {}

    generateAdditionalInfoRequest (formData: FormDataApis, id: string): AdditonalInfoBody {
        const confirmationDigitalInfo: any = this.CommonsSessionStorageService.get('confirmationDigitalInfo');
        const additionalInfoRequest: AdditonalInfoBody = [
            {
                id: id,
                disruptionContact: {
                    language: confirmationDigitalInfo.Language,
                    email: formData.contactData.additionalInfo.email,
                    phone: {
                        countryCode: formData.contactData.additionalInfo.phone.value,
                        number: formData.contactData.additionalInfo.number
                    }
                }
            }
        ];
        return additionalInfoRequest;
    }

    generateSecurityRequest (formData: FormDataApis, id: string): SecurityRequest {
        const securityRequest: SecurityRequest = [
            {
                emergencyContact:
                    formData.contactData.emergencyInfo.name && formData.contactData.emergencyInfo.number && formData.contactData.emergencyInfo.phone
                        ? {
                            refused: false,
                            name: formData.contactData.emergencyInfo.name,
                            phone: {
                                countryCode: formData.contactData.emergencyInfo.phone.value,
                                number: formData.contactData.emergencyInfo.number
                            }
                        }
                        : undefined,
                destinationAddress: formData.passengerAddress
                    ? {
                        state: formData.passengerAddress.state.value,
                        country: ApisConstants.USA_NATIONALITY,
                        zipCode: formData.passengerAddress.zipCode,
                        city: formData.passengerAddress.city,
                        address: formData.passengerAddress.address
                    }
                    : undefined,
                homeAddress: { country: formData.personalData.country?.value ?? 'ES' },
                id: id,
                inTransit: false,
                name: formData.personalData.name,
                surname: formData.personalData.surname,
                gender: formData.personalData.gender,
                birthDate: formData.personalData.birthDate,
                nationality: formData.personalData.nationality.value,
                documents: this.getSecurityRequestDocuments(formData),
                infantPassengerSecurityInformation: formData.infant
                    ? {
                        id: null,
                        requiredFields: [],
                        name: formData.infant.personalData.name,
                        surname: formData.infant.personalData.surname,
                        gender: formData.infant.personalData.gender,
                        birthDate: formData.infant.personalData.birthDate,
                        nationality: formData.infant.personalData.nationality.value,
                        cityOfBirth: null,
                        countryOfResidence: null,
                        documents: this.getSecurityRequestDocuments(formData.infant)
                    }
                    : undefined
            }
        ];

        return securityRequest;
    }

    getSecurityRequestDocuments (formData: FormDataApis | FormDataApisInfant) {
        const documents: Document[] = [this.setDocumentFormToRequest(formData.documentationRequired.mandatory)];
        if (formData.documentationRequired.other?.number) documents.push(this.setDocumentFormToRequest(formData.documentationRequired.other));
        if (formData.documentationRequired.visa?.number) documents.push(this.setDocumentFormToRequest(formData.documentationRequired.visa));
        return documents;
    }

    setDocumentFormToRequest (document: DocumentForm): Document {
        return { ...document, type: (document.type as SelectOptions)?.value || '', issuerCountry: (document.issuerCountry as SelectOptions)?.value || '' };
    }

    generateNewsLetterInfo (formData: FormDataApis) {
        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        const cachedInfo = bookingInfo.outwardSegments && bookingInfo.outwardSegments.length > 0 ? bookingInfo.outwardSegments : bookingInfo.returnSegments;
        const newsLetterRequest = {
            email: formData.contactData.additionalInfo.email ?? '',
            name: formData.personalData.name ?? '',
            departureCity: cachedInfo[0].departure.airport.code ?? '',
            destinationCity: cachedInfo[0].arrival.airport.code ?? '',
            language: this.$rootScope.appLang ?? '',
            country: formData.personalData.country.value ?? '',
            birthDate: formData.personalData.birthDate ?? '',
            unsubscribe: formData.checkbox.notSendNewsletter ?? false
        };
        return newsLetterRequest;
    }

    generateCustomerTravelInfo (passengers) {
        const customerTravelInfo = {
            name: '',
            surname: '',
            gender: '',
            birthDate: '',
            nationality: {
                code: ''
            },
            documents: []
        };
        return customerTravelInfo;
    }
}
